// components/CartMapView.tsx
import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import icon from "../../../assets/icons/cart.PNG";
import { RESTAURANT_ID } from "../../../constants/constans";
import "./index.css"; // 🔥 Import the CSS file
import { Container, Spinner } from "react-bootstrap";
import { useFirebaseAllCarts } from "../../../hooks/useFirebaseCartData";

export interface Locations {
  id: string;
  name: string;
  displayName?: string;
  lat: number;
  lng: number;
  imageUrl: string;
  isFixedLocation: boolean;
}

const defaultCenter = {
  lat: 6.9270786,
  lng: 79.861243,
};

const libraries: ("places" | "geometry" | "marker")[] = [
  "places",
  "geometry",
  "marker",
];

const CartMapView: React.FC = () => {
  const restaurantId = RESTAURANT_ID;
  const iconURL =
    "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Icons/cart-icon.png";

  const [cartList, setCartList] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentLocation, setCurrentLocation] =
    useState<google.maps.LatLngLiteral | null>(null);
  // const { data, isFetching } = useGetCartListByRestaurantIdQuery(restaurantId);
  const { data, loading: isFetching } = useFirebaseAllCarts(restaurantId);
  // console.log("📍 CartMapView - Fetched cart data:", data);
  const [locationList, setLocationList] = useState<Locations[]>([]);
  const [selectedCart, setSelectedCart] = useState<Locations | null>(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY! ||
      "AIzaSyD_zEfLidcypXTaAVeiQVX5PHlrcj6xEpM",
    libraries,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }, []);

  useEffect(() => {
    if (data) {
      setCartList(data);
    }
  }, [data]);

  useEffect(() => {
    const filteredCartList = cartList.filter(
      (cart) => cart.status === "Approved" && cart?.reasonForBeingOffline !== "Cart under maintenance"
    );
    // console.log("📍 CartMapView - Original cart list:", cartList);
    // console.log("📍 CartMapView - Filtered cart list:", filteredCartList);
    const mappedLocations: Locations[] = filteredCartList.map((cart: any) => ({
      id: cart.id,
      name: cart.displayName,
      lat: cart.location.latitude,
      lng: cart.location.longitude,
      imageUrl: cart.imageUrl,
      isFixedLocation: cart.isFixedLocation,
    }));
    setLocationList(mappedLocations);
  }, [cartList]);

  if (!isLoaded || isFetching) {
    return (
      <div className="loading-container">
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
          <div className="text-center">
            <div className="loading-spinner mb-4">
              <Spinner 
                animation="border" 
                variant="primary" 
                style={{ 
                  width: '4rem', 
                  height: '4rem',
                  borderWidth: '4px',
                  color: '#3f0213'
                }} 
              />
            </div>
            <h4 className="loading-title mb-3">Loading Carts</h4>
            <p className="loading-text text-muted">
              Please wait while we fetch Carts information...
            </p>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <GoogleMap
      mapContainerClassName="cart-map-container" // 🔥 Use className instead of style
      center={defaultCenter}
      zoom={14}
      options={{
        disableDefaultUI: false,
        clickableIcons: false,
        styles: [],
      }}
    >
      {locationList.map((cart) => (
        <Marker
          key={cart.id}
          position={{ lat: cart.lat, lng: cart.lng }}
          icon={{
            url: cart.isFixedLocation ? iconURL : icon,
            scaledSize: new window.google.maps.Size(40, 40),
          }}
          onMouseOver={() => setSelectedCart(cart)}
        />
      ))}

      {selectedCart && (
        <InfoWindow
          position={{ lat: selectedCart.lat, lng: selectedCart.lng }}
          options={{ pixelOffset: new window.google.maps.Size(0, -40) }}
        >
          <div className="cart-info-window"> {/* 🔥 Use CSS class */}
            <h5>{selectedCart.name}</h5>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};

export default CartMapView;
